import '../../../services/polyfills/string.prototype.padstart';

export const numberFormatter = value => {
  /* istanbul ignore next */
  const numberFormat = new Intl.NumberFormat('de-DE');
  /* istanbul ignore next */
  return numberFormat.format(value);
};
